    import { GNUserPublic } from '../auth/types';
    import { GNProjectPublic } from '../projects/types';

    // Billing Data
    export interface BillingUsageRow {
      project_id?: string;
      lambda_gb_seconds: number;
      lambda_reqs: number;
      ddb_read_units: number;
      ddb_write_units: number;
      ddb_gb_seconds: number;
      sqs_reqs: number;
      apigw_rest_reqs: number;
      ws_connect_sec: number;
      ws_msg_in: number;
      ws_msg_out: number;
      s3_put_list_reqs: number;
      s3_get_reqs: number;
      s3_gb_seconds: number;
      sm_serverless_seconds: number;
      sm_data_in_gb: number;
      sm_data_out_gb: number;
      bandwidth_gb: number;
      session_count: number;
      symbolic_upload_count: number;
      symbolic_upload_gb: number;
      crash_reporter_upload_count: number;
      crash_reporter_upload_gb: number;
    }

    export interface BillingDataDB {
      yearMonth: string; // e.g. "2023-09"
      usageUnits: BillingUsageRow;
      usageCosts: BillingUsageRow;
      totalCost: number;
    }

    export interface AdminGNProjectPublic extends GNProjectPublic {
      projectOwnerID: string
      billingData?: BillingDataDB[];
    }

    // BE data interfaces
    export interface AdminGNUserDB extends GNUserPublic {
        lastVisitTimestamp: number,
        projects: AdminGNProjectPublic[];
    }

    /**
     * Defines Admin interface
     */
    export interface AdminDashboardData {
        users: AdminGNUserDB[];
        systemCostData: BillingDataDB[];
        updateTimestamp: number;
    }
  
    /**
     * Defines Admin State interface
     */
    
    export interface AdminState {
        // http state
        httpInProgress: boolean;
        httpError: string;
        // http state for project block/unblock
        httpBlockProjectID?: string;
        // project cost http state
        httpProjectCostsInProgress: boolean;
        httpProjectCostsError: string;
        // BE data
        adminData: AdminDashboardData | undefined;
    }
    
    /**
     * Defines Admin action names
     */
    export const ADMIN_DASHBOARD_IN_PROGRESS = 'ADMIN_DASHBOARD_IN_PROGRESS'
    export const ADMIN_DASHBOARD_ERROR = 'ADMIN_DASHBOARD_ERROR'
    export const ADMIN_DASHBOARD_GET = 'ADMIN_DASHBOARD_GET'
    export const ADMIN_PROJECT_COSTS_IN_PROGRESS = 'ADMIN_PROJECT_COSTS_IN_PROGRESS'
    export const ADMIN_PROJECT_COSTS_GET = 'ADMIN_PROJECT_COSTS_GET'
    export const ADMIN_PROJECT_COSTS_ERROR = 'ADMIN_PROJECT_COSTS_ERROR'
    export const ADMIN_BLOCK_PROJECT = 'ADMIN_BLOCK_PROJECT'
    
    /**
     * Defines Admin action interfaces
     */
    interface AdminDashboardInProgressAction {
      type: typeof ADMIN_DASHBOARD_IN_PROGRESS;
    }
    interface AdminDashboardErrorAction {
      type: typeof ADMIN_DASHBOARD_ERROR;
      error: string;
    }
    interface AdminDashboardGetAction {
      type: typeof ADMIN_DASHBOARD_GET;
      adminData: AdminDashboardData;
    }
    interface AdminProjectCostsInProgressAction {
      type: typeof ADMIN_PROJECT_COSTS_IN_PROGRESS;
    }
    interface AdminProjectCostsErrorAction {
      type: typeof ADMIN_PROJECT_COSTS_ERROR
      error: string;
    }
    interface AdminProjectCostsGetAction {
      type: typeof ADMIN_PROJECT_COSTS_GET;
      userID: string;
      projectID: string;
      projectBillingData: BillingDataDB[];
    }
    interface AdminBlockProjectAction {
      type: typeof ADMIN_BLOCK_PROJECT;
      projectID: string;
    }

    /**
     * Defines all suported actions for Admin
     */
    export type AdminActionTypes =
      AdminDashboardInProgressAction |
      AdminDashboardErrorAction |
      AdminDashboardGetAction |
      AdminProjectCostsInProgressAction |
      AdminProjectCostsErrorAction |
      AdminProjectCostsGetAction |
      AdminBlockProjectAction;
    
    /**
     * Defines AdminActionsInterface
     */
    export interface AdminActionsInterface {
      adminDashboardGet: () => Promise<void>;
      adminProjectCostsGet: (userID: string, projectID: string) => Promise<void>;
      adminUpdateUserRole: (userID: string, userRole: string) => Promise<void>;
      adminBlockProject: (projectID: string) => Promise<void>;
      adminUnblockProject: (projectID: string) => Promise<void>;
    }
    